import {RootStore} from './RootStore';
import {action} from 'mobx';
import agent from '../api/agent';

class DocumentStore{
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
      this.rootStore = rootStore; 
    }

    @action getDocumentList = async (strm: string, type: string, emplid: string, acadProg: string) => {
        try 
        {   
            const list = await agent.Documents.documentList(strm, type, emplid, acadProg);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getUserRole = async (emplid: string) => {
        try 
        {   
            const list = await agent.Documents.userRole(emplid);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getLecturer = async (emplid: string) => {
        try 
        {   
            const list = await agent.Documents.lecturerList(emplid);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getTerm = async (institution: string, career: string) => {
        try 
        {   
            const list = await agent.Documents.termList(institution, career);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action getLecturerData = async (emplid: string) => {
        try 
        {   
            const list = await agent.Documents.lecturerData(emplid);
            return list;
        } catch (error) {
            throw error;
        }
    };

    @action deleteDocument = async (docNo: string, emplid: string) => {
        try 
        {   
            const del = await agent.Documents.deleteDoc(docNo, emplid);
            return del;
        } catch (error) {
            throw error;
        }
    };
}

export default DocumentStore;